import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/main.css'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import { applyTheme } from './utils/themeUtils'

const app = createApp(App)

// 应用主题
applyTheme()

// Toast配置
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
})

app.use(router).mount('#app')
